export const LocationUtil = {
    getLatitude: (geoaddress) => {
        let latitude = 0;

        if (geoaddress.latitude) {
            latitude = parseFloat(geoaddress.latitude);
        } else if (geoaddress._latitude) {
            latitude = parseFloat(geoaddress._latitude);
        } else if (geoaddress._lat) {
            latitude = parseFloat(geoaddress._lat);
        }

        return latitude;
    },
    getLongitude: (geoaddress) => {
        let longitude = 0;

        if (geoaddress.longitude) {
            longitude = parseFloat(geoaddress.longitude);
        } else if (geoaddress._longitude) {
            longitude = parseFloat(geoaddress._longitude);
        } else if (geoaddress._long) {
            longitude = parseFloat(geoaddress._long);
        }

        return longitude;
    },
    getAreaRadius: (radius) => {
        let number = 0;
        if (radius) {
            number = parseInt(radius);
        }
        return number;
    },
    getCoordinates: (geoaddress) => {
        const { latitude, longitude } = geoaddress || {};
        if (latitude && longitude) {
            return `(${latitude.toFixed(6)}, ${longitude.toFixed(6)})`;
        }
        return "N/A";
    },
    getGeoaddress: (geoaddress) => {
        const { latitude = 0, longitude = 0 } = geoaddress || {};
        return {
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude)
        };
    },
};